import { useCurrentUser } from "../../../../AuthWrapper2/hooks/useCurrentUser.js";
import { UserName } from "../../../../Users/shared/UserName.js";
import { UserAnPCheck } from "../../../../shared/UserAnPCheck.js";
import { EditButton } from "../../../../../components/Buttons/index.js";
import { EventDispositionFormBuilderInput } from "./components/FormBuilderInput.js";
import { FormBuilderDisplayRenderer } from "../../../../FormBuilder/components/FormBuilderDisplayRenderer/index.js";
import { EventAssignedUserStatusHistory } from "../components/EventAssignedUserStatusHistory.js";
import { useState } from "react";
import { Button, Constants, Icon, Tabs, useContainerDimensionsContext } from "@therms/atalaya";
import { IoMdAdd } from "react-icons/io";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { MdTaskAlt } from "react-icons/md";
//#region src/modules/Events/shared/EventInteractive/EventDispositionFormBuilder/index.tsx
function EventDispositionFormBuilder({ allowEdit, event, eventType, refresh, showAssignedUserStatusHistory }) {
	const [assignedUserIdEditing, setAssignedUserIdEditing] = useState();
	const currentUser = useCurrentUser();
	const { viewport: { width: viewportWidth } } = useContainerDimensionsContext();
	const isMobileLayout = viewportWidth < Constants.Breakpoint.Sm.width;
	const [tab, setTab] = useState(() => {
		if (event.assignedUsers.find(({ userId }) => currentUser.id === userId)) return currentUser.id;
		return event.assignedUsers?.[0]?.userId;
	});
	if (assignedUserIdEditing) return /* @__PURE__ */ jsxs("div", {
		className: classnames({ "flex-col": isMobileLayout }, "flex"),
		children: [/* @__PURE__ */ jsx("div", {
			className: "pb-xs grow",
			children: /* @__PURE__ */ jsx(EventDispositionFormBuilderInput, {
				assignedUserId: assignedUserIdEditing,
				event,
				eventType,
				onCancel: () => setAssignedUserIdEditing(void 0),
				onComplete: () => {
					setAssignedUserIdEditing(void 0);
					refresh?.();
				}
			})
		}), showAssignedUserStatusHistory && /* @__PURE__ */ jsx(EventAssignedUserStatusHistory, {
			event,
			userId: assignedUserIdEditing
		})]
	});
	return /* @__PURE__ */ jsxs("div", { children: [!event.assignedUsers.length && /* @__PURE__ */ jsx("div", {
		className: "my-base text-color-neutral text-center",
		children: "No Assigned Users - No Disposition can be added"
	}), /* @__PURE__ */ jsx(Tabs, {
		currentKey: tab,
		onTabClick: setTab,
		pills: true,
		children: event.assignedUsers.map(({ user, userId }) => {
			const formInput = event.dispositionFormInputByAssignedUserId?.[userId];
			return /* @__PURE__ */ jsx(Tabs.Tab, {
				tabKey: userId,
				title: /* @__PURE__ */ jsxs("div", { children: [event.dispositionFormInputByAssignedUserId?.[userId] && /* @__PURE__ */ jsxs("span", { children: [/* @__PURE__ */ jsx(Icon, {
					color: "positive",
					Icon: MdTaskAlt,
					size: "sm"
				}), " "] }), /* @__PURE__ */ jsx(UserName, { user })] }),
				children: /* @__PURE__ */ jsxs("div", {
					className: classnames({
						flex: !isMobileLayout,
						"flex-col": isMobileLayout
					}),
					children: [/* @__PURE__ */ jsxs("div", {
						className: classnames({
							"pb-xs": isMobileLayout,
							"pr-xs": !isMobileLayout
						}, "grow"),
						children: [formInput ? /* @__PURE__ */ jsx(FormBuilderDisplayRenderer, {
							formId: formInput.formId,
							valuesByFieldId: formInput.fields
						}, userId) : /* @__PURE__ */ jsxs("div", {
							className: "flex flex-col items-center justify-center",
							children: [/* @__PURE__ */ jsx("div", {
								className: "text-color-neutral inline-flex h-24 justify-center",
								children: /* @__PURE__ */ jsxs("em", { children: [
									"No disposition has been entered by",
									" ",
									/* @__PURE__ */ jsx(UserName, { user })
								] })
							}), /* @__PURE__ */ jsx(UserAnPCheck, {
								check: (user) => user.anp.role.ops.permissions.createEvents && event.history?.createdBy === user.id || user.anp.role.ops.permissions.editEvents || user.id === userId,
								children: /* @__PURE__ */ jsxs(Button, {
									className: "gap-x-xxs",
									fullWidth: isMobileLayout,
									onClick: () => setAssignedUserIdEditing(userId),
									variant: "main",
									children: [
										/* @__PURE__ */ jsx(Icon, {
											Icon: IoMdAdd,
											size: "sm"
										}),
										" ",
										/* @__PURE__ */ jsx("span", { children: "Add Disposition" })
									]
								})
							})]
						}), allowEdit && /* @__PURE__ */ jsx(UserAnPCheck, {
							check: (user) => user.anp.role.ops.permissions.createEvents && event.history?.createdBy === user.id || user.anp.role.ops.permissions.editEvents || user.id === userId,
							children: /* @__PURE__ */ jsx("div", {
								className: "flex justify-end",
								children: formInput && /* @__PURE__ */ jsx(EditButton, {
									fullWidth: isMobileLayout,
									onClick: () => setAssignedUserIdEditing(userId)
								})
							})
						})]
					}), showAssignedUserStatusHistory && /* @__PURE__ */ jsx(EventAssignedUserStatusHistory, {
						event,
						userId
					})]
				})
			}, userId);
		})
	})] });
}
//#endregion
export { EventDispositionFormBuilder };

//# sourceMappingURL=index.js.map